module.exports = __webpack_public_path__ + "static/media/desktop-cmf.773b37f3.svg";